import { MESSAGE_STATUSES } from '../../models/messaging-message';
import { concat, fn } from '@ember/helper';
import { eq } from 'ember-truth-helpers';
import { formatReadAtDate } from '../../utils/messaging/format-date';
import { noop } from 'ember-composable-helpers/helpers/noop';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import styles from './message-subtext.module.scss';

export default class ConversationMessageMessageSubtext extends Component {
  @service intl;

  get shouldShowReadIndicator() {
    return (
      Object.keys(this.args.conversation.counterpartReadAt).length > 0 &&
      this.args.message === this.args.conversation.lastReadOwnMessage
    );
  }

  get validCounterpartReadAt() {
    // Filters out readAts from older messages.
    return Object.entries(this.args.conversation.counterpartReadAt).filter(([_, value]) => {
      return new Date(value) > new Date(this.args.message.createdAt);
    });
  }

  // This is currently used only for deleted messages to show all readAts
  get readAtsFromMemberships() {
    if (!Array.isArray(this.args.message.readMemberships)) {
      return [];
    }

    return this.args.message.readMemberships.map(membership => {
      const clientName = this.args.conversation.users.find(
        user => String(user.id) === String(membership.user_id)
      )?.name;

      const args = [
        this.intl,
        membership.read_at,
        this.args.conversation.isCouple ? clientName : null,
      ];

      return formatReadAtDate(...args);
    });
  }

  // Used for regular messages based on conversation level counterpartReadAt
  get readAts() {
    if (this.args.message.deletedAt) {
      return this.readAtsFromMemberships;
    }

    return this.validCounterpartReadAt.map(([clientId, readAt]) => {
      const clientName = this.args.conversation.users.find(
        user => String(user.id) === String(clientId)
      )?.name;
      const args = [this.intl, readAt, this.args.conversation.isCouple ? clientName : null];
      return formatReadAtDate(...args);
    });
  }

  get onResendHandler() {
    return this.args.onResend || noop;
  }

  <template>
    <div class="{{styles.component}} message-subtext" data-test-message-subtext>
      {{#if @message.deletedAt}}
        {{#each this.readAts as |readAt|}}
          <p class="read-at" data-test-read-at>
            {{readAt}}
          </p>
        {{/each}}
      {{else if this.shouldShowReadIndicator}}
        {{#each this.readAts as |readAt|}}
          <p class="read-at" data-test-read-at>
            {{readAt}}
          </p>
        {{/each}}
      {{else if (eq @message.status MESSAGE_STATUSES.FAILED)}}
        <span
          class="failed"
          role="button"
          {{on "click" (fn this.onResendHandler @message)}}
          data-test-resend
        >
          {{t "emc.message_status.failed"}}
        </span>
      {{else}}
        {{t (concat "emc.message_status." @message.status)}}
      {{/if}}
    </div>
  </template>
}
